import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHeadTypes} from "../../constants";

export default class ShowerTrimKit extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_trim_kit';
    this.partName = 'Shower Trim Kit';
    this.translateId = "visualizer.bathroom.shower.shower_trim_kit";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_trim_kit);
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_trim_kit && this.activeFeature
  }
}
